// Clinq brand strings — keep in one place so we can rename consistently.
// The trademark symbol "™" is freely usable for unregistered marks.

// Default = Indicative (algorithmic AI score). Verified is the paid human-
// expert-reviewed upgrade. UI components switch on company.verified_readiness_status.
export const CFR_FULL = "Indicative Capital Readiness Score\u2122";
export const CFR_SHORT = "Indicative CCR Score\u2122";
export const CFR_FULL_PLAIN = "Indicative Capital Readiness Score";
export const CFR_SHORT_PLAIN = "Indicative CCR Score";

export const CFR_FULL_VERIFIED = "Verified Capital Readiness Score\u2122";
export const CFR_SHORT_VERIFIED = "Verified CCR Score\u2122";
export const CFR_FULL_VERIFIED_PLAIN = "Verified Capital Readiness Score";
export const CFR_SHORT_VERIFIED_PLAIN = "Verified CCR Score";

// Pricing for the human-reviewed verified upgrade (KES).
export const VERIFIED_PRICE_USD = 50000;

/** Pick the right report label based on verified status. */
export function reportFullLabel(status) {
  return status === "verified" ? CFR_FULL_VERIFIED : CFR_FULL;
}

export function reportShortLabel(status) {
  return status === "verified" ? CFR_SHORT_VERIFIED : CFR_SHORT;
}
